// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPackPitch-cls1_V_7","cls2":"LoswpPackPitch-cls2_Juw LoswpPackPitch-cls1_V_7"};